<template>
  <div class="container">
    <div class="banner-join">
      <div class="banner-join-wrap mb-0">
        <div class="banner-join-title">
          Генеральный партнер
        </div>
        <div class="row justify-content-center">
          <div class="col-12 col-md-7">
            <div class="banner-join-border flex-column">
              <a class="d-flex banner-join-item _general mx-auto mb-5" href="https://els24.com/" target="_blank">
                <div class="banner-join-subtitle">
                  Европейская Юридическая Служба
                </div>
                <img class="img-fluid" :src="require(`@/assets/els-logo.svg`)">
              </a>
              <a class="d-flex banner-join-item _general mx-auto" href="https://neuromir.ru/" target="_blank">
                <div class="banner-join-subtitle">
                  НЕЙРОМИР
                </div>
                <img class="img-fluid" :src="require(`@/assets/neuromir.svg`)">
                <div class="banner-join-subtitle mt-4">
                  КОМПАНИЯ НЕЙРОМИР — Территория развития мозга.<br> Разрабатываем и внедряем проекты с применением<br>
                  нейротехнологий в бизнесе и жизни
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="banner-join">
      <div class="banner-join-wrap mb-4">
        <div class="banner-join-title">
          Официальные партнеры мероприятия
        </div>
        <div class="banner-join-border">
          <div class="banner-join-item">
            <div class="banner-join-subtitle">
              Portal VR
            </div>
            <img class="img-fluid" :src="require(`@/assets/partners/vr-p.svg`)">
          </div>
          <div class="banner-join-item">
            <div class="banner-join-subtitle">
              Школа ведической<br> нумерологии<br> «Энверсия»
            </div>
            <img class="img-fluid" :src="require(`@/assets/partners/enversia.png`)">
          </div>
          <div class="banner-join-item">
            <div class="banner-join-subtitle">
              СПА-салон<br> KASANIE
            </div>
            <img class="img-fluid" :src="require(`@/assets/partners/kasanie.svg`)">
          </div>
          <div class="banner-join-item">
            <div class="banner-join-subtitle">
              Цветочный салон<br> «BLOOM FLOWER»
            </div>
            <img class="img-fluid" :src="require(`@/assets/partners/bloom flower.svg`)">
          </div>
          <div class="banner-join-item">
            <div class="banner-join-subtitle">
              Пространство<br> для женщин<br> «Pheromone»
            </div>
            <img class="img-fluid" :src="require(`@/assets/partners/pheromone.svg`)">
          </div>
        </div>
      </div>
      <div class="banner-join-wrap mb-0">
        <div class="banner-join-title">
          Питьевой партнер
        </div>
        <div class="banner-join-border">
          <div class="banner-join-item _big">
            <div class="banner-join-subtitle">
              Smart-вода 8:00
            </div>
            <img class="img-fluid" :src="require(`@/assets/partners/smart-v.svg`)">
          </div>
        </div>
        <GlobalButton class="_secondary mt-4 mt-md-0 mx-auto"
                      data-bs-toggle="modal"
                      data-bs-target="#FormFeedback">
          Хочу стать партнером
        </GlobalButton>
      </div>
    </div>
  </div>
</template>

<script>
import GlobalButton from "@/components/GlobalButton";

export default {
  name: "BannerJoin",
  components: {GlobalButton}
}
</script>

<style lang="scss" scoped>
.banner-join {
  border-radius: 16px;
  background: linear-gradient(174deg, rgba(255, 255, 255, 0.2) 0%, rgba(0, 0, 0, 0) 9.37%), #0D0D10;
  padding: 24px 36px 36px;
  margin-top: 60px;

  @include _768 {
    background: #0D0D10;
    padding: 40px 60px;
    margin-top: 120px;
  }
}

.banner-join-wrap {
  display: flex;
  flex-direction: column;
  margin-bottom: 90px;

  .banner-join-title {
    color: var(--white, #FFF);
    text-align: center;
    font-family: Play, serif;
    font-size: 26px;
    font-style: normal;
    font-weight: 700;
    line-height: 138%; /* 35.88px */
    margin-bottom: 20px;
    @include _768 {
      font-size: 38px;
      margin-bottom: 34px;
    }
  }

  .banner-join-border {
    border-radius: 8px;
    border: 1px solid var(--all-Deep-dark, #3D3F59);
    padding: 20px 30px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    flex-wrap: wrap;
    @include _576 {
      flex-direction: row;
    }

    .banner-join-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-bottom: 16px;
      width: 100%;
      @include _576 {
        width: 50%;
      }
      @include _768 {
        width: auto;
      }

      &:last-child {
        img {
          height: 58px;
        }
      }

      &._big {
        img {
          height: 73px;
        }
      }

      &._general {
        img {
          height: 100%;
        }
      }

      img {
        height: 68px;
        width: auto;
        margin-top: auto;
      }
    }

    @include _768 {
      margin-bottom: 50px;
    }
  }

  .banner-join-subtitle {
    color: var(--white, #FFF);
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 128%; /* 20.48px */
    margin-bottom: 18px;
  }

  .global-button {
    padding-left: 1rem;
    padding-right: 1rem;
    @include _576 {
      padding-left: 100px;
      padding-right: 100px;
    }
  }
}
</style>